import React, { useEffect, useState } from "react";
import { animateScroll } from "react-scroll";
import { FaArrowUp } from "react-icons/fa";

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      onClick={() => animateScroll.scrollToTop({ duration: 500 })}
      aria-label="Scroll to top"
      className={`fixed bottom-24 lgl:bottom-6 right-4 lgl:right-6 z-40 w-12 h-12 rounded-full bg-designColor text-white inline-flex items-center justify-center shadow-lg shadow-black/40 hover:-translate-y-1 transition-all duration-300 ${
        visible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <FaArrowUp />
    </button>
  );
};

export default ScrollToTop;
